import { AnhangDataType } from '@eBeihilfe/einreichung-shared/model';
import { ConverterService, EndToEndEncrypter } from '@ebeihilfe/core';
import { EinreichungApiService } from '@eBeihilfe/einreichung-shared/services';

export class Seite {
  public thumb = '';
  protected _id: string | null = null;
  protected _file?: Blob;
  protected _dataType: AnhangDataType | null = null;
  protected _uploaded = false;
  protected _size = 0;
  constructor(
    protected converterService: ConverterService,
    protected einreichungsApi: EinreichungApiService,
    protected endToEndEncrypter: EndToEndEncrypter,
  ) {}

  public get id(): string {
    return <string>this._id;
  }

  public set id(value: string) {
    this._id = value;
  }

  public get dataType(): string {
    return <string>this._dataType;
  }

  public set dataType(value: AnhangDataType) {
    this._dataType = value;
  }

  public get uploaded(): boolean {
    return this._uploaded;
  }

  public set uploaded(value: boolean) {
    this._uploaded = value;
  }

  public async getSize(): Promise<Readonly<number>> {
    return this._size;
  }

  public setSize(size: number): void {
    this._size = size;
  }

  public async setFile(file: Blob): Promise<void> {
    this._file = file;
    this._size = file.size;
    await this.setThumb();
  }

  public getFile(): Promise<Blob> {
    return Promise.resolve(this._file || new Blob());
  }
  protected async setThumb(): Promise<void> {
    this.thumb = await this.converterService.blobToBase64Thumb(this._file || new Blob());
  }
}
